<template>
    <div class="auto-recharge-order">
        <!-- 导航栏 -->
        <topHead>
            <img slot="head" src="../../assets/images/fh.png" alt="" @click="backBefor()" />
            <h3 slot="header">自动充值订单</h3>
        </topHead>

        <!-- 内容 -->
        <div class="main">
            <!-- 订单列表 -->
            <div class="order-list" v-if="orderList.length > 0">
                <div class="order-item" v-for="(order, index) in orderList" :key="index">
                    <div class="order-header">
                        <span class="order-time">{{ order.createTime }}</span>
                        <span class="order-status" :class="order.statusClass">{{ order.status }}</span>
                    </div>
                    <div class="order-body">
                        <div class="order-info">
                            <div class="info-item">
                                <span class="label">手机号</span>
                                <span class="value">{{ order.mobilePhone }}</span>
                            </div>
                            <div class="info-item">
                                <span class="label">充值金额</span>
                                <span class="value amount">{{ order.amount }}元</span>
                            </div>
                            <div class="info-item">
                                <span class="label">充值周期</span>
                                <span class="value">{{ order.period }}</span>
                            </div>
                            <div class="info-item">
                                <span class="label">充值日期</span>
                                <span class="value">{{ order.rechargeDate }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="order-footer" v-if="order.status === '待支付'">
                        <van-button type="info" size="small" @click="payOrder(order)">立即支付</van-button>
                    </div> -->
                </div>
            </div>

            <!-- 空状态 -->
            <div class="empty-state" v-else>
                <p>暂无自动充值订单</p>
            </div>
        </div>

        <!-- 加载中 -->
        <load :load="load">
            <p slot="text" class="loadText">加载中...</p>
        </load>
    </div>
</template>

<script>
import topHead from "../../components/topHead.vue"
import load from "../../components/load.vue"
import API from "../../common/api/api"
import { Toast } from "vant"
export default {
    name: "AutoRechargeOrder",
    data() {
        return {
            orderList: [
                {
                    id: 1,
                    mobilePhone: "13800138000",
                    amount: 100,
                    period: "月",
                    rechargeDate: 15,
                    status: "待支付",
                    createTime: "2023-08-15 10:00:00"
                },
                {
                    id: 2,
                    mobilePhone: "13800138001",
                    amount: 200,
                    period: "月",
                    rechargeDate: 10,
                    status: "已支付",
                    createTime: "2023-08-16 12:00:00"
                },
            ],
            load: false,
            isSubmitting: false
        }
    },
    created() {
        this.getOrderList()
    },
    methods: {
        // 获取订单列表
        getOrderList() {
            this.load = true
            API.getJson("GET_AUTO_RECHARGE_ORDER", {}).then(res => {
                if (res && res.length > 0) {
                    this.orderList = res.map(item => {
                        return {
                            ...item,
                            statusClass: this.getStatusClass(item.status),
                            createTime: this.formatTime(item.createTime),
                            rechargeDate: `每月${item.rechargeDate}日`
                        }
                    })
                }
            }).catch(err => {
                Toast({
                    message: "获取订单列表失败",
                    position: "bottom"
                })
            }).finally(() => {
                this.load = false
            })
        },

        // 获取状态样式
        getStatusClass(status) {
            switch (status) {
                case '待支付':
                    return 'status-pending'
                case '已支付':
                    return 'status-paid'
                case '已取消':
                    return 'status-canceled'
                default:
                    return ''
            }
        },

        // 格式化时间
        formatTime(time) {
            if (!time) return ''
            const date = new Date(time)
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        },

        // 支付订单
        payOrder(order) {
            if (this.isSubmitting) return
            this.isSubmitting = true
            // 这里可以添加支付逻辑
            Toast({
                message: "跳转到支付页面",
                position: "bottom"
            })
            this.isSubmitting = false
        },

        // 去设置自动充值
        goToAutoRecharge() {
            this.$router.push("/Recharge")
        },

        // 返回上一页
        backBefor() {
            this.$router.back()
        }
    },
    components: {
        topHead,
        load
    }
}
</script>

<style lang="scss" scoped>
.main {
    padding: px2rem(20);
    min-height: calc(100vh - px2rem(100));
}

.order-list {
    .order-item {
        background-color: #fff;
        border-radius: px2rem(12);
        padding: px2rem(20);
        margin-bottom: px2rem(20);
        box-shadow: 0 0 px2rem(10) rgba($color: #000000, $alpha: 0.05);

        .order-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: px2rem(15);
            padding-bottom: px2rem(15);
            border-bottom: 1px solid #f0f0f0;

            .order-time {
                font-size: px2rem(22);
                color: #666;
            }

            .order-status {
                font-size: px2rem(22);
                font-weight: 500;

                &.status-pending {
                    color: #ff9500;
                }

                &.status-paid {
                    color: #4cd964;
                }

                &.status-canceled {
                    color: #999;
                }
            }
        }

        .order-body {
            .order-info {
                .info-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: px2rem(12);

                    .label {
                        font-size: px2rem(24);
                        color: #666;
                    }

                    .value {
                        font-size: px2rem(24);
                        color: #333;

                        &.amount {
                            font-weight: bold;
                            color: #ff3b30;
                        }
                    }
                }
            }
        }

        .order-footer {
            margin-top: px2rem(15);
            padding-top: px2rem(15);
            border-top: 1px solid #f0f0f0;
            display: flex;
            justify-content: flex-end;

            .van-button {
                font-size: px2rem(22);
                padding: 0 px2rem(30);
            }
        }
    }
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: px2rem(100) 0;

    img {
        width: px2rem(200);
        height: px2rem(200);
        margin-bottom: px2rem(30);
        opacity: 0.5;
    }

    p {
        font-size: px2rem(24);
        color: #999;
        margin-bottom: px2rem(40);
    }

    .van-button {
        font-size: px2rem(24);
        padding: 0 px2rem(60);
    }
}

.loadText {
    font-size: px2rem(24);
    color: #666;
}
</style>
